import React, { useEffect, useState, useRef } from 'react';
import { RgbaColorPicker } from 'react-colorful';
import { TextField, Grid, Box, Typography } from '@mui/material';

import './color.css'


export default function ColorPicker({ onChange = () => { } }) {
  const [color, setColor] = useState({ r: 255, g: 0, b: 0, a: 1 });

  const handleInputChange = (key, value) => {
    const num = Math.max(0, Math.min(key === 'a' ? 1 : 255, parseFloat(value) || 0));
    setColor((prev) => ({ ...prev, [key]: num }));
  };

  const toHex = ({ r, g, b }) =>
    '#' + [r, g, b].map((x) => x.toString(16).padStart(2, '0')).join('');

  const toHSL = ({ r, g, b, a }) => {
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    let h = 0,
      s,
      l = (max + min) / 2;

    if (max === min) h = s = 0;
    else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
      }
      h *= 60;
    }

    return {
      h: Math.round(h),
      s: Math.round(s * 100),
      l: Math.round(l * 100),
      a,
    };
  };

  const hsl = toHSL(color);
  const hex = toHex(color);
  useEffect(() => {
    onChange(hex)
  }, [color])

  return (
    <Box className="color-picker" sx={{ p: 1, borderRadius: 1 }}>
      <Typography variant="body2" gutterBottom fontSize={12}>Fill color</Typography>
      <RgbaColorPicker color={color} onChange={setColor} />
      <Grid container spacing={1} mt={1}>
        {['r', 'g', 'b', 'a'].map((key) => (
          <Grid item xs={3} key={key}>
            <TextField
              sx={{ p: 0, maxWidth: 44, height: 20 }}
              label={key.toUpperCase()}
              type="number"
              value={color[key]}
              onChange={(e) => handleInputChange(key, e.target.value)}
              size="small"
              inputProps={{
                min: 0,
                max: key === 'a' ? 1 : 255,
                step: key === 'a' ? 0.01 : 1,
              }}
            />
          </Grid>
        ))}
      </Grid>

      <Box mt={2}>
        <Typography fontSize={12} variant="body2">Hex: <b>{hex}</b></Typography>
        <Typography fontSize={12} variant="body2">
          HSL: <b>hsl({hsl.h}, {hsl.s}%, {hsl.l}%)</b>
        </Typography>
        <Typography fontSize={12} variant="body2">
          RGBA: <b>rgba({color.r}, {color.g}, {color.b}, {color.a})</b>
        </Typography>
      </Box>
    </Box>
  );
}